<template>
  <page-wrapper ref="pageEl" :title="title">
    <div v-if="bookDetail && conferenceDetail" class="conference-detail row">
      <div class="col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12 customer">
        <h5 class="mb-4">รายละเอียดผู้จอง</h5>
        <div class="mb-4">
          <p>ชื่อ</p>
          <h6>{{ bookDetail.firstName }} {{ bookDetail.lastName }}</h6>
        </div>
        <div class="mb-4">
          <p>เบอร์โทรศัพท์</p>
          <h6>{{ bookDetail.mobile }}</h6>
        </div>
        <div class="mb-4">
          <p>อีเมล</p>
          <h6>{{ bookDetail.email }}</h6>
        </div>
        <div class="mb-4">
          <p>บริษัท</p>
          <h6>{{ bookDetail.companyName }}</h6>
        </div>
        <div class="mb-4">
          <p>ที่อยู่</p>
          <h6>{{ bookDetail.address }}</h6>
        </div>
      </div>
      <div class="col-xl-9 col-lg-9 col-md-12 col-sm-12 col-12 booking">
        <div class="header mb-4">
          <h5>รายละเอียดการจอง</h5>
        </div>
        <div class="row">
          <div class="col-xl-3 col-lg-3 col-md-6 col-md-6 col-md-6">
            <p>ห้องประชุม</p>
            <h6>{{ conferenceDetail.title }}</h6>
          </div>
          <div class="col-xl-3 col-lg-3 col-md-6 col-md-6 col-md-6">
            <p>ขนาด</p>
            <h6>{{ conferenceDetail.usable }}</h6>
          </div>
          <div class="col-xl-3 col-lg-3 col-md-6 col-md-6 col-md-6">
            <p>ที่ตั้ง</p>
            <h6>{{ conferenceDetail.address }}</h6>
          </div>
        </div>
        <div class="book-info">
          <div class="mt-3 mb-4 row">
            <div class="col-xl-3 col-lg-3 col-md-6 col-md-6 col-md-6 mb-4">
              <p>Booking No.</p>
              <h6>{{ bookDetail.id }}</h6>
            </div>
            <div class="col-xl-3 col-lg-3 col-md-6 col-md-6 col-md-6">
              <p>สถานะ</p>
              <div :class="status.value">
                <el-select
                  :value="bookDetail.status"
                  clearable
                  style="width: 100%"
                  @input="
                    handleChangeInput(
                      $event,
                      'status'
                    )
                  "
                >
                  <el-option
                    v-for="p in conferenceBookingStatus"
                    :key="p.value"
                    :value="p.value"
                    :label="p.label"
                    >{{ p.label }}</el-option
                  >
                </el-select>
              </div>
            </div>
            <div class="col-xl-3 col-lg-3 col-md-6 col-md-6 col-md-6">
              <p>วันที่จอง</p>
              <h6>{{ bookDate }}</h6>
            </div>
            <div
              class="col-xl-3 col-lg-3 col-md-6 col-md-6 col-md-6 right"
            ></div>
            <div class="col-xl-3 col-lg-3 col-md-6 col-md-6 col-md-6">
              <p>event name</p>
              <h6>{{ bookDetail.eventName }}</h6>
            </div>
            <div class="col-xl-3 col-lg-3 col-md-6 col-md-6 col-md-6">
              <p>event detail</p>
              <h6>{{ bookDetail.eventDetail }}</h6>
            </div>
          </div>
          <div class="detail">
            <booking-manage-box
              :conference-detail="conferenceDetail"
              :booking-detail="bookingDetail"
              :is-admin-row="true"
            ></booking-manage-box>
          </div>
        </div>
      </div>
    </div>
  </page-wrapper>
</template>

<script>
import { baanRueJaiClient } from "@/dependencies";
import { conferenceBookingStatus } from "@/lib/mapper";
import { convertDateTimeToTimeText } from "@/lib/dateTime";
import { Option, Select } from "element-ui";
import { toCamelCaseObject } from "../../../lib/util";
import BookingManageBox from "../component/BookingManageBox";
import PageWrapper from "../../../lib/components/PageWrapper";

export default {
  components: {
    PageWrapper,
    BookingManageBox,
    "el-option": Option,
    "el-select": Select,
  },
  data() {
    return {
      title: "รายละเอียดการจอง",
      bookingDetail: null,
      conferenceDetail: null,
    };
  },
  computed: {
    bookDetail() {
      return toCamelCaseObject(this.bookingDetail);
    },
    status() {
      if (!this.bookDetail || !this.bookDetail.status) {
        return { label: "unknown", value: "UNKNOWN" };
      }

      const bookingStatus = conferenceBookingStatus.find(
        (stat) => stat.value === this.bookDetail.status
      );

      return bookingStatus || { label: "unknown", value: "UNKNOWN" };
    },
    bookDate() {
      return this.bookDetail
        ? convertDateTimeToTimeText(this.bookDetail.createdAt)
        : null;
    },
    conferenceBookingStatus() {
      return conferenceBookingStatus;
    },
  },
  created() {
    this.setup();
  },
  methods: {
    async setup() {
      await this.setupConferenceBookingDetail();
    },
    async setupConferenceBookingDetail() {
      this.bookingDetail = await this.fetchBooking();

      await this.setupConferenceProjectDetail();
    },
    async fetchBooking() {
      const { id } = this.$route.params;

      try {
        return await baanRueJaiClient.others.conference.getConferenceBookingDetail(
          id
        );
      } catch (err) {
        return [];
      }
    },
    async setupConferenceProjectDetail() {
      this.conferenceDetail = await this.fetchConference();
    },
    async fetchConference() {
      if (!this.bookingDetail || !this.bookingDetail.room_id) {
        return null;
      }

      try {
        return await baanRueJaiClient.others.conference.getConferenceById(
          this.bookingDetail.room_id
        );
      } catch (err) {
        return null;
      }
    },
    handleChangeInput(value, key) {
      this.bookingDetail = {
        ...this.bookingDetail,
        [key]: value
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.conference-detail {
  padding: 15px;
}

.booking {
  border-left: solid 1px #d9d9d9;

  > .book-info {
    border-top: solid 2px #2d2a26;
  }
}

.right {
  text-align: right;
}

p {
  line-height: 1.6;
  font-size: 0.9rem;
  color: #777;
}

.badge {
  font-size: 0.9rem;
  padding: 4px 10px;
  border-radius: 4px;
  margin: auto;

  &.PENDING {
    background-color: $secondary-color;
  }

  &.CONFRIMED {
    background-color: $warning-color;
  }

  &.DONE {
    background-color: $success-color;
  }

  &.CANCELED {
    background-color: $danger-color;
  }

  &.UNKNOWN {
    background-color: $danger-color;
  }
}
</style>